<template>
  <div class="w-100 h-100">
    <data-viewer></data-viewer>
  </div>
</template>

<script>
  import DashboardBaseTemplate from '@/layouts/DashboardBaseTemplate.vue'

  import {
    HTTP
  } from '@/utilities/http-common';
  import HandleErrors from '@/utilities/handle-errors';

  import DataViewer from '@/components/srilanka/DataViewer.vue'

  import {
    mapActions
  } from 'vuex';

  const studyName = process.env.VUE_APP_STUDY;

  export default {
    mixins: [DashboardBaseTemplate],
    components: {
      DataViewer
    },
    beforeRouteUpdate(to, from, next) {
      this.updateView(to.query.view);
      next();
    },
    data() {
      return {
        headers: [],
        data: [],
        title: '',
        view: ''
      }
    },
    created() {
      this.updateView(this.$route.query.view);
    },
    // add watch to detect route.path change and update view
    watch: {
      '$route.path': function(val, oldVal) {
        this.updateView(this.$route.query.view);
      }
    },
    methods: {
      ...mapActions('websheet', ['updateView']),
      fetchData(view = "") {
        const that = this;
        HTTP.get('/' + (studyName != null ? studyName : 'kenya') + '/generic-data/', {
          params: {
            view: view
          }
        }).then(response => {
          that.headers = response.data.headers;
          that.data = response.data.data;
          that.title = response.data.title;
        }).catch((error) => {
          HandleErrors.HandleErrors(error);
        });
      }
    }
  };
</script>

<style>
</style>
